import {memo} from "react";
import {Box, BoxProps} from "@chakra-ui/react";

export const InteractionsLayer = memo((props: BoxProps) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      overflow="hidden"
      touchAction="none"
      userSelect="none"
      pointerEvents="auto"
      {...props}
    />
  );
});
